import React from 'react';

import svg from './assets/icons-24-visibility-on.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconVisibilityOn = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-visibility-on" />
);
